export default __webpack_public_path__ + "static/media/symbol2.37a93925.svg";